import { useState, useEffect } from "react";
import { useEventReport } from "../redux/ReduxContext";

export interface OiCommentsData {
    manufacturingMachine: string;
    manufacturingComment: string;
}



export default function OiComments() {
    const { state, dispatch } = useEventReport();
    const { taggedElements, taggedElementsComments } = state;



    return (
        <div className="bg-white dark:bg-oi-dark-background p-4 flex flex-col mb-4 drop-shadow-md">
            <div className="flex flex-col lg:flex-row items-stretch mt-2 gap-4 lg:gap-6">
                <div className="w-full lg:w-1/2">
                    <h6 className="">Manufacturing Machine</h6>
                    <input
                        type="text"
                        placeholder="ie.104505 or Magda 01"
                        value={taggedElements[0]}
                        onChange={(e) => dispatch({ type: 'UPDATE_ARRAY_ITEM', payload: { field: 'taggedElements', index: 0, value: e.target.value } })}
                        className="h-12 w-full p-2 pr-10 mt-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 border bg-primary-light dark:bg-primary-dark border-gray-300 dark:border-gray-600 placeholder-gray-400"
                    />

                </div>

                <div className="w-full lg:w-1/2">
                    <h6>Manufacturing comment</h6>

                    <textarea
                        className="resize-y border  w-full p-2 mt-2 pt-3
             text-sm focus:outline-none focus:ring-2 
             bg-primary-light dark:bg-primary-dark 
             border-gray-300 dark:border-gray-600 
             placeholder-gray-400 min-h-12 overflow-hidden"
                        placeholder="Add additional comments here..."
                        rows={1}
                        value={taggedElementsComments[0]}
                        onChange={(e) => {
                            dispatch({ type: 'UPDATE_ARRAY_ITEM', payload: { field: 'taggedElementsComments', index: 0, value: e.target.value } });
                            e.target.style.height = "auto";
                            e.target.style.height = `${e.target.scrollHeight}px`;
                        }}
                    />
                </div>
            </div>
        </div>
    );
}